// let result = gcoord.transform(
//   [116.403988, 39.914266],    // 经纬度坐标
//   gcoord.WGS84,               // 当前坐标系
//   gcoord.BD09                 // 目标坐标系
// );
// console.log(result);  // [116.41661560068297, 39.92196580126834]
/*
* current_coordinate 当前坐标系
* target_coordinate  目标坐标系
* longitude          经度
* latitude           纬度
*/
function gcoord_transform(current_coordinate,target_coordinate,longitude,latitude) {
  let result = gcoord.transform(
    [longitude, latitude],            // 经纬度坐标
    current_coordinate,               // 当前坐标系
    target_coordinate                 // 目标坐标系
  );

  return result;
}

// 获取两坐标之间的距离，距离单位为km
// function getDistance(lat1, lng1, lat2, lng2){
//     let radLat1 = lat1 * Math.PI / 180.0;
//     let radLat2 = lat2 * Math.PI / 180.0;
//     let a = radLat1 - radLat2;
//     let  b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
//     let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) +
//     Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b/2),2)));
//     s = s * 6378.137 ;// EARTH_RADIUS;
//     s = Math.round(s * 10000) / 10000;
//     return s;
// }

function getDistanceByBaiduMapApi(lng1,lat1,lng2,lat2) {
  let map = new BMap.Map("allmap");
  let pointA = new BMap.Point(lng1,lat1);  // 创建点坐标A
  let pointB = new BMap.Point(lng2,lat2);  // 创建点坐标B
  let range = map.getDistance(pointA,pointB).toFixed(2);  //获取两点距离,保留小数点后两位
  return range;
}

function getDistance(lat1, lng1, lat2, lng2) {
  let distance = 0;
  let radLat1 = toRad(lat1);
  let radLat2 = toRad(lat2);
  let deltaLat = radLat1 - radLat2;
  let deltaLng = toRad(lng1) - toRad(lng2);
  distance = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
  distance = distance * 6378137;
  
  return distance.toFixed(2);
} 

/*
 * 计算两点对于正北方向的朝向角度 [0,360]
 * @param {*} lat1 坐标1 纬度
 * @param {*} lng1 坐标1 经度
 * @param {*} lat2 坐标2 纬度
 * @param {*} lng2 坐标2 经度
 */
function bearing(lat1, lng1, lat2, lng2) {
  let	radLat1 = toRad(lat1);
  let	radLat2 = toRad(lat2);
  let	radLon1 = toRad(lng1);
  let	radLon2 = toRad(lng2);
  const a = Math.sin(radLon2 - radLon1) * Math.cos(radLat2);
  const b = Math.cos(radLat1) * Math.sin(radLat2) -
          Math.sin(radLat1) * Math.cos(radLat2) * Math.cos(radLon2 - radLon1);

  return radiansToDegrees(Math.atan2(a, b));
}

/*
 * 弧度转换为角度
 * @param {*} radians 弧度
 */
function radiansToDegrees(radians) {
  const degrees = radians % (2 * Math.PI);
  return toDeg(degrees);
}

/**
 * 度换成弧度
 * @param {*} d 度
 * @returns  弧度
 */
function toRad(d) {  
  return d * Math.PI / 180; 
}

/**
 * 弧度换成度
 * @param {*} x 弧度
 * @return   度
 */
function toDeg(d){
  return d * 180 / Math.PI;
};

export { gcoord_transform,getDistance,bearing }
